import React, {useState, useEffect} from 'react';
import CartStore from './flux/CartStore';
import MainNavCartIcon from './MainNavCartIcon';

export default function MainNavCart() {
  // const cartInfo = props.json;
  // console.log(cartInfo.item_count);

  const [cartInfo, setCartInfo] = useState(CartStore.getCartJSON());
  useEffect(() => {
    const emitter = CartStore.addListener('cartAJAX', () => {
      setCartInfo(CartStore.getCartJSON());
    });
    return () => { emitter.remove() }
  });

  function showCount() {
    return (
      <span class="count">
        {cartInfo.item_count}
      </span>
    )
  }

  return (
    <a
      className={cartInfo.item_count > 0 ? "mini-cart cart-active" : "mini-cart cart-empty"}
      href="/cart"
    >
      <label>Cart</label>
      {cartInfo.item_count > 0 ? showCount() : showCount()}
      <MainNavCartIcon />
    </a>
  );
}